import React from 'react';
import { Sidebar } from '@fingo/lib/components/layout';
import InvoiceProfile from '../views/App/supplierAutomate/invoice/InvoiceProfile';

const invoiceSubRoutes = [
  {
    id: 'profile',
    label: 'Documento',
    path: 'profile',
    component: <InvoiceProfile />,
    disabled: false,
    show: true,
  },
];

const supplierAutomateRoutes = () => [
  {
    id: 'invoice',
    label: 'Invoice',
    path: '/app/invoice',
    component: <Sidebar goBack options={invoiceSubRoutes} />,
    disabled: false,
    show: true,
    showInNavbar: false,
    subRoutes: [],
  },
];

export default supplierAutomateRoutes;
